import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { LOGO_WHITE } from "@/lib/api";

const navItems = [
  { label: "Services", href: "/services", absolute: true },
  { label: "FAQ", href: "/faq", absolute: true },
  { label: "About", href: "#about" },
  { label: "Engagements", href: "#engagements" },
  { label: "Contact", href: "#contact" },
];

export const Header = ({ solid = false, linkBase = "" }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const filled = solid || scrolled;
  const links = navItems.map((l) => ({ ...l, href: l.absolute ? l.href : `${linkBase}${l.href}` }));

  return (
    <motion.header
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color,padding] duration-500 ${
        filled ? "bg-navy/90 backdrop-blur-xl border-b border-white/10 py-3" : "bg-transparent py-6"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 flex items-center justify-between">
        <a href={linkBase || "#top"} data-testid="header-logo" className="flex items-center gap-3">
          <img src={LOGO_WHITE} alt="Park Communications logo" className="h-10 w-auto" />
        </a>
        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-ivory/80 hover:text-ivory text-sm tracking-wide link-underline"
            >
              {l.label}
            </a>
          ))}
          <a
            href={`${linkBase}#contact`}
            data-testid="header-cta"
            className="text-xs overline text-navy bg-gold hover:bg-gold-dark transition-colors px-6 py-3"
          >
            Start a conversation
          </a>
        </nav>
        <button
          className="md:hidden text-ivory text-sm overline"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? "Close" : "Menu"}
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-navy border-t border-white/10 px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-ivory/90 text-lg font-serif">
              {l.label}
            </a>
          ))}
        </div>
      )}
    </motion.header>
  );
};
